<div class="mx-auto">
 

  <div class="card">
    <!-- <div class="register-logo">
      <a [routerLink]="['/admin-list']"><b>Admin</b></a>
    </div> -->
    <div class="card-body register-card-body">
      <!-- <p class="login-box-msg" *ngIf="admin_id === null">Register A New Membership</p>
      <p class="login-box-msg" *ngIf="admin_id !== null">Edit An Already Exist Member</p> -->

      <form [formGroup]="registerForm" (ngSubmit)="register()">
        <div class="row">
          <!-- First Name -->
          <div class="input-group mb-3 col-6">
            <input
              formControlName="firstName"
              type="text"
              maxLength="30"
              class="form-control"
              placeholder="First Name"
              (keypress)="onlyAlphabetKey($event)"
            />
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-user"></span>
              </div>
            </div>
          </div>
          <!-- <div *ngIf="registerForm.get('firstName')?.invalid && registerForm.get('firstName')?.touched" class="text-danger">
            First name must contain only letters.
          </div> -->
      
          <!-- Last Name -->
          <div class="input-group mb-3 col-6">
            <input
              formControlName="lastName"
              type="text"
              maxLength="30"
              class="form-control"
              placeholder="Last Name"
              (keypress)="onlyAlphabetKey($event)"
            />
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-user"></span>
              </div>
            </div>
          </div>
          <!-- <div *ngIf="registerForm.get('lastName')?.invalid && registerForm.get('lastName')?.touched" class="text-danger">
            Last name must contain only letters.
          </div> -->
        </div>
      
        <!-- Other Fields -->
        <div class="row">
          <div class="input-group mb-3 col-6">
            <input formControlName="email" type="email" class="form-control" placeholder="Email" maxLength="50" />
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-envelope"></span>
              </div>
            </div>
          </div>
      
          <div class="input-group mb-3 col-6">
            <input formControlName="mobile" type="tel" maxLength="10" class="form-control" placeholder="Mobile No."
              (keypress)="onlyNumberKey($event)" />
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-phone"></span>
              </div>
            </div>
          </div>
        </div>
      
        <!-- Password Fields -->
        <div class="row">
          <div class="input-group mb-3 col-6" *ngIf="admin_id === null">
            <input formControlName="password" type="password" class="form-control" placeholder="Password" />
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-lock"></span>
              </div>
            </div>
          </div>
        
          <div class="input-group mb-3 col-6" *ngIf="admin_id === null">
            <input formControlName="retypePassword" type="password" class="form-control" placeholder="Retype Password" />
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-lock"></span>
              </div>
            </div>
          </div>
        
          <!-- Password requirements message -->
          <div *ngIf="registerForm.get('password')?.touched && registerForm.get('password')?.invalid" class="text-danger">
            Password must be at least 8 characters long, contain at least one uppercase letter, and one special character.
          </div>
        
          <!-- Show error message if passwords don't match -->  
        </div>
        
      
        <!-- Submit Button -->
        <div class="row">
          <div class="btn-align">
            <app-button [type]="'submit'" [block]="true" [text]="'Submit'" [loading]="isAuthLoading" [color]="'info'"
              class="button" [disabled]="isAuthDisabled"></app-button>
            &nbsp;
            <button type="button" [disabled]="isAuthDisabled" class="btn btn-secondary btn-block"
              [routerLink]="['/admin-list']">Cancel</button>
          </div>
        </div>
      </form>
      

      <!-- <div class="social-auth-links text-center">
        <p>- OR -</p>
        <a href="#" class="btn btn-block btn-primary">
          <i class="fab fa-facebook mr-2"></i>
          Sign up using Facebook
        </a>
        <a href="#" class="btn btn-block btn-danger">
          <i class="fab fa-google-plus mr-2"></i>
          Sign up using Google+
        </a>
      </div>

    </div> -->
    <!-- <a [routerLink]="['/login']" class="text-center">I already have a membership</a> -->
    <!-- /.form-box -->
  </div>
  <!-- /.card -->
</div>
